import React from "react";
import { Box } from "@mui/material";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import KpiCard from "./KpiCard";

const AuditSummaryWidget = ({ data, loading }) => (
  <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
    <KpiCard
      icon={EventNoteOutlinedIcon}
      label="Total Events (24h)"
      value={data?.totalEvents}
      loading={loading}
      color="#0288d1"
    />
    <KpiCard
      icon={VisibilityOutlinedIcon}
      label="Patient Activity (24h)"
      value={data?.dataAccessEvents}
      loading={loading}
      color="#7b1fa2"
    />
    <KpiCard
      icon={LoginOutlinedIcon}
      label="Login Attempts (24h)"
      value={data?.loginAttempts}
      loading={loading}
      color="#f57c00"
    />
  </Box>
);

export default AuditSummaryWidget;
